import { rem } from 'polished'
import React from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import HeroImage from 'content/components/HeroImage'
import Subtitle from 'LuxKit/Typography/Subtitle'
import Heading from 'LuxKit/Typography/Heading'
import SearchForm from 'components/Search/SearchForm'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES } from 'constants/search'
import config from 'constants/config'
import { isSearchEnabled } from 'lib/search/searchUtils'
import { connect } from 'react-redux'
import { useTrendingDestinationsLabels } from './hooks/userTrendingLabels'

const HeroContainer = styled(HeroImage)`
  min-height: unset;
  padding: ${rem(40)} 0;

  ${mediaQueryUp.tablet} {
    min-height: ${rem(289)};
  }
`

const HotelSearchContainerPaneContent = styled.div`
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

const HotelSearchBarFloating = styled.div`
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  width: 100%;
  z-index: 1;

  &.floating-search-bar {
    position: relative;
    transform: unset;
    margin-top: ${rem(32)};
  }
`

interface Props {
  floatingSearchBar?: boolean
}

function HotelPageSearchHero({ floatingSearchBar, trendingDestinations, isSearchEnabled }: Props & MappedStateProps) {
  const trendingDestinationsLabels = useTrendingDestinationsLabels(trendingDestinations)

  return <>
    {isSearchEnabled && <HeroContainer
      gravity="auto"
      aria-hidden="true"
      brightness={-25}
      id={config.searchFormSection.hotelsImageId}
      tabletAspectRatio="16:3"
    >
      <LayoutContainer relative>
        <Group direction="vertical" horizontalAlign="start" tabletHorizontalAlign="center" gap={8}>
          <Heading colour="neutral-eight" variant="heading2" className="hero-heading center">
            <i>Hotels & Resorts</i> to dream about
          </Heading>
          <Subtitle variant="subtitle3" colour="neutral-eight" className="center">
            Choose hotels & resorts from our curated collection
          </Subtitle>
        </Group>
      </LayoutContainer>

      <HotelSearchBarFloating className={cn({ 'floating-search-bar': floatingSearchBar })}>
        <LayoutContainer>
          <CSSBreakpoint min="tablet">
            <HotelSearchContainerPaneContent>
              <SearchForm
                submitOnApply
                typeaheadTypes={HOTEL_SEARCH_TYPEAHEAD_TYPES}
              />
            </HotelSearchContainerPaneContent>
          </CSSBreakpoint>

          <CSSBreakpoint max="mobile">
            <GlobalMobileSearchHeroBar
              placeholder="Search hotels in"
              placeholderTextList={trendingDestinationsLabels}
            />
          </CSSBreakpoint>
        </LayoutContainer>
      </HotelSearchBarFloating>
    </HeroContainer>}
  </>
}

interface MappedStateProps {
  trendingDestinations: Array<App.TrendingDestination>;
  isSearchEnabled: boolean;
}

const mapStateToProps = (state: App.State): MappedStateProps => ({
  trendingDestinations: state.destination.trendingDestinations,
  isSearchEnabled: isSearchEnabled(),
})

export default connect(mapStateToProps)(HotelPageSearchHero)
